import { apiClient } from "@/lib/apiClient";
import { apiPath } from "@/lib/apiPath";
import { getServiceRegistry } from "./serviceRegistrySingleton";

/**
 * Fetch service categories + services payload and merge into ServiceRegistry.
 * Uses apiPath() so the widget bootstrap can switch to public scope.
 */
export async function fetchServiceCatalog(): Promise<void> {
  const url = apiPath("/services/service_categories");
  const { data } = await apiClient.get(url);
  // `data` is expected to be the payload described in docs (categories + services + staff)
  getServiceRegistry().mergeFromResponse(data);
}
